import { render, staticRenderFns } from "./FormElementEmail.vue?vue&type=template&id=1f31f968"
import script from "./FormElementEmail.vue?vue&type=script&lang=js"
export * from "./FormElementEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports